import { useEffect } from "react";
import seo from "@/data/seo-pages.json";
import blogPosts from "@/data/blog-posts.json";
import { resolvePageMeta } from "@/lib/seo-meta.mjs";

const setMeta = (selector, attr, key, content) => {
  let el = document.head.querySelector(selector);
  if (content == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

/**
 * Holder <head> i takt med siden ved klient-navigation. Første indlæsning har allerede
 * den rigtige head fra scripts/prerender.mjs — det her er til skift mellem sider.
 */
export function usePageSeo(pathname) {
  useEffect(() => {
    const meta = resolvePageMeta(pathname, { seo, posts: blogPosts });
    document.title = meta.title;
    setMeta('meta[name="description"]', "name", "description", meta.description);
    setMeta('meta[property="og:title"]', "property", "og:title", meta.title);
    setMeta('meta[property="og:description"]', "property", "og:description", meta.description);
    setMeta('meta[property="og:url"]', "property", "og:url", meta.canonical);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", meta.title);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", meta.description);
    setMeta('meta[name="robots"]', "name", "robots", meta.noindex ? "noindex, follow" : null);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!meta.canonical) {
      if (link) link.remove();
    } else {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", meta.canonical);
    }
  }, [pathname]);
}
